import { useQuickBooksStore } from '@/domains/integrations/quickbooks/stores/quickBooksStore'

export async function ensureQuickBooksAccess(to, from) {
  // If the route does not require QuickBooks access, allow navigation
  if (!to?.meta?.requiresQuickBooks) {
    return { allowed: true }
  }

  // Allow navigation if only query parameters changed (not path or name)
  const isQueryOnlyNavigation =
    !!from &&
    String(to?.path || '') === String(from?.path || '') &&
    String(to?.name || '') === String(from?.name || '')
  if (isQueryOnlyNavigation) {
    return { allowed: true }
  }

  // Check QuickBooks authentication status
  const quickBooksStore = useQuickBooksStore()
  await quickBooksStore.checkAuthStatus()
  const hasQuickBooksAccess =
    quickBooksStore.isAuthenticated && !quickBooksStore.requiresReconnect
  if (hasQuickBooksAccess) {
    // User is authenticated and does not need to reconnect
    return { allowed: true }
  }

  // If not authenticated, redirect to top-level segment (e.g. /invoices)
  const topLevelSegment = String(to.path.split('/')[1] || '').trim()
  const fallbackPath = topLevelSegment ? `/${topLevelSegment}` : '/'
  // Prevent redirect loop: if already at fallback, allow
  if (fallbackPath === to.path) {
    return { allowed: true }
  }
  // Otherwise, block and redirect
  return { allowed: false, redirectPath: fallbackPath }
}
